import { render, staticRenderFns } from "./LglRequirementReportBI.vue?vue&type=template&id=d95e7fb8&"
import script from "./LglRequirementReportBI.vue?vue&type=script&lang=js&"
export * from "./LglRequirementReportBI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports